import React, { ReactNode } from 'react';
import { CrownFilled } from '@ant-design/icons';
import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';

interface Props {
  centreId?: string;
  textValue?: string;
  icon?: ReactNode;
  isBlur?: boolean;
}

const TextFallback = ({ centreId, textValue, icon, isBlur }: Props) => {
  const onOpenModal = () => {
    upgradeModal.open(null, centreId);
  };

  return (
    <div
      className="normal-action-wrapper cursor-pointer"
      onClick={onOpenModal}
      role="presentation"
    >
      <div className="flex mt-8">
        {icon}
        <span className={`${isBlur ? 'blur' : ''} break-all`}>{textValue}</span>
      </div>
      <CrownFilled className="action-feature-icon" />
    </div>
  );
};

export default TextFallback;
